module.exports = __webpack_public_path__ + "static/img/norefund.3688dd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/norefund.png
// module id = X2oG
// module chunks = 1